<template>
  <div class="d-flex fl-ae fl-jc" @click.stop="showScanQRCodeModal()">
    <SvgIcon
      :iconContent="QRCodeScanSvg"
      :iconAlt="t('qrcode.icon-alt')"
      :iconStyle="iconStyle"
      class="qr-code-scan-button"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { SvgIcon } from "@/components/index";
import QRCodeScanSvg from "@/assets/images/svg/qr-code-scan.svg";
import ModalModule from "@/store/modules/modal";
import { ModalStatus } from "@/constants/modal";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "NavbarScanQrCode",
  components: {
    SvgIcon,
  },
  setup() {
    const { t } = useI18n({});
    const iconStyle = "filter: contrast(170%) invert(100%);";
    return {
      t,
      QRCodeScanSvg,
      iconStyle,
    };
  },
  methods: {
    showScanQRCodeModal() {
      ModalModule.setStatus(ModalStatus.ScanQrCode);
    },
  },
});
</script>
<style>
.qr-code-scan-button {
  cursor: pointer;
}
</style>
